export enum CopyStatus {
  NOT_COPIED = 0,
  COPIED = 1,
  ACTIVE = 2
}
